var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProcessed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 5.29449C19.2626 5.1768 19.0908 5.09172 18.9082 5.04412C18.7256 4.99652 18.536 4.98733 18.35 5.01708C18.1641 5.04682 17.9855 5.11493 17.8246 5.21749C17.6636 5.32005 17.5234 5.45507 17.4119 5.61482L10.6227 15.3335L6.30556 11.6902C6.00789 11.4497 5.63274 11.3418 5.26052 11.3896C4.8883 11.4373 4.54864 11.637 4.31434 11.9458C4.08005 12.2546 3.96977 12.6479 4.00714 13.0414C4.04452 13.4349 4.22658 13.7974 4.51429 14.051L9.99582 18.6758C10.1473 18.8008 10.3209 18.8927 10.5064 18.9461C10.6919 18.9995 10.8857 19.0134 11.0763 18.987C11.267 18.9605 11.4507 18.8943 11.6169 18.7921C11.783 18.6899 11.9281 18.5538 12.0438 18.3918L19.7223 7.40746C19.8337 7.24741 19.9141 7.06577 19.9589 6.87292C20.0036 6.68008 20.012 6.47982 19.9833 6.28359C19.9547 6.08736 19.8897 5.899 19.792 5.72928C19.6943 5.55957 19.5659 5.41182 19.414 5.29449Z",
    fill: "#2DCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProcessed);
export default __webpack_public_path__ + "static/media/upload-processed.df831aacf52ee66846e6f7088e25eac7.svg";
export { ForwardRef as ReactComponent };